import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "@/configurations/index";
import { getMSALCache } from "@/services/security/msalToken";
// Remove React hooks and use a function to get sessionId from the Redux state
import type { IUserState } from "@/features/User/userSlice";

// Define a service using a base URL and expected endpoints
export const sodApi = createApi({
  reducerPath: "sodApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.APIUrl,
    prepareHeaders: async (headers) => {
      const backendAccessToken = getMSALCache();
      if (backendAccessToken) {
        headers.set("Authorization", `Bearer ${backendAccessToken.secret}`);
      }
      
       // Use dynamic import instead of require
      const storeModule = await import("@/store");
      const store = storeModule.store;
      if (store && typeof store.getState === "function") {
        const state = store.getState();
        const sessionId = (state.user as IUserState)?.sessionId;
        if (sessionId) {
          headers.set("Session-Key", `${sessionId}`);      
        }
      }
      return headers;
    },
    fetchFn: async (input, init) => {
      const response = await fetch(input, init);
      if (response.status === 401) {
        window.location.href = "/logout";
      }
      return response;
    },
  }),
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    healthcheck: builder.query<{ status: string }, void>({
      query: () => "/case/health",
    }),
  }),  
});

export const { useLazyHealthcheckQuery } = sodApi;
